/**
 * Snackbar Plugin for Vue
 * Provides a global $snackbar method for showing notifications
 */

const SnackbarPlugin = {
    install(Vue) {
        // Create a Vue instance to act as an event bus
        const eventBus = new Vue();
        
        // Store the event bus on Vue prototype for the GlobalSnackbar component
        Vue.prototype.$snackbarBus = eventBus;
        
        // Create a global snackbar API
        Vue.prototype.$snackbar = {
            show(options) {
                // Emit event to the GlobalSnackbar component
                eventBus.$emit('snackbar:show', options);
            },
            
            // Convenience methods for common use cases
            success(text, options = {}) {
                this.show({
                    text,
                    color: 'success',
                    ...options
                });
            },
            
            error(text, options = {}) {
                this.show({
                    text,
                    color: 'error',
                    timeout: 6000, // Errors stay longer
                    ...options
                });
            },
            
            warning(text, options = {}) {
                this.show({
                    text,
                    color: 'warning',
                    ...options
                });
            },
            
            info(text, options = {}) {
                this.show({
                    text,
                    color: 'info',
                    ...options
                });
            }
        };
        
        // Also add to the root instance for backward compatibility
        Vue.mixin({
            beforeCreate() {
                if (this.$options.name === 'Root' || !this.$parent) {
                    this.$snackbar = Vue.prototype.$snackbar;
                }
            }
        });
    }
};

export default SnackbarPlugin;